import { render } from "./SchemaMarkupButton.vue?vue&type=template&id=db32dc2a"
import script from "./SchemaMarkupButton.vue?vue&type=script&lang=js"
export * from "./SchemaMarkupButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__